import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { Area, ConfiguratorState, GetTemplatesFields, GetTemplateWithDocType, OTemplate } from 'models/configurator';
import { Template } from 'models/response';
import { TableRowsType } from 'routes/Configurator/routes/Mapper/utils';

// TEMPLATES
const setTemplates: CaseReducer<ConfiguratorState, PayloadAction<Template[]>> = (state, { payload }) => {
  state.views = payload;
};
const setActiveDocTypeId: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.mapper.activeDocTypeId = payload;
};
const setActiveOTemplate: CaseReducer<ConfiguratorState, PayloadAction<OTemplate | null>> = (state, { payload }) => {
  state.mapper.activeOTemplate = payload;
};
const setActiveOTemplateId: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.mapper.activeOTemplateId = payload;
};
const setDocTypes: CaseReducer<ConfiguratorState, PayloadAction<GetTemplateWithDocType[]>> = (state, { payload }) => {
  state.mapper.docTypes = payload;
};
const setMapperFields: CaseReducer<ConfiguratorState, PayloadAction<GetTemplatesFields>> = (state, { payload }) => {
  state.mapper.fields = payload;
};
const setMapperEditRowId: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.mapper.templateEditRowID = payload;
};

const setMapperSelectedRowId: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.mapper.templateSelectedRowID = payload;
};

const setMapperRows: CaseReducer<ConfiguratorState, PayloadAction<TableRowsType[]>> = (state, { payload }) => {
  state.mapper.rows = payload;
};

const setMapperAreas: CaseReducer<ConfiguratorState, PayloadAction<Area[]>> = (state, { payload }) => {
  state.mapper.areas = payload;
};
const setTemplateNewName: CaseReducer<
  ConfiguratorState,
  PayloadAction<{ docTypeId: number; templateId: number; name: string }>
> = (state, { payload }) => {
  const { docTypeId, templateId, name } = payload;
  const docType = state.mapper.docTypes.find((dt) => dt.idDocType === docTypeId);
  if (docType) {
    const template = docType.oTemplateList.find((t) => t.idTemplate === templateId);
    if (template) {
      template.templateName = name;
    }
  }
};
const setNewOtemplate: CaseReducer<ConfiguratorState, PayloadAction<OTemplate>> = (state, { payload }) => {
  const docType = state.mapper.docTypes.find((dt) => dt.idDocType === payload.idDocType);
  if (docType) {
    docType.oTemplateList.push(payload);
  }
};
const removeOtemplate: CaseReducer<ConfiguratorState, PayloadAction<{ idDocType: number; idTemplate: number }>> = (
  state,
  { payload },
) => {
  const docType = state.mapper.docTypes.find((dt) => dt.idDocType === payload.idDocType);
  if (docType) {
    docType.oTemplateList = docType.oTemplateList.filter((t) => t.idTemplate !== payload.idTemplate);
  }
};
const setCurrentPdfPage: CaseReducer<ConfiguratorState, PayloadAction<number>> = (state, { payload }) => {
  state.mapper.pdfCurrentPage = payload;
};
const deleteRowOrSingleSubRow: CaseReducer<ConfiguratorState, PayloadAction<{ id: number }>> = (state, { payload }) => {
  const { id } = payload;
  const { rows } = state.mapper;
  const newRows = rows;
  const row = newRows.findIndex((r) => Number(r.id) > id);
  if (row === -1) {
    // means that we are removing last row or subrow
    const lastRow = newRows[newRows.length - 1];
    if (Number(lastRow.id) === id) {
      // removing last row
      newRows.pop();
      return;
    }
    // removing the subrow of last row with id === id
    const subRow = lastRow.subRows?.findIndex((sr: any) => Number(sr.id) === id);
    if (subRow !== -1) {
      if (lastRow.subRows?.length === 1) {
        newRows.pop();
        return;
      }
      lastRow.subRows?.splice(subRow, 1);
      return;
    }
  }
  // removing row
  if (Number(newRows[row - 1]?.id) === id) {
    newRows.splice(row - 1, 1);
    return;
  }
  // removing subrow
  const subRow = newRows[row - 1].subRows?.findIndex((sr: any) => Number(sr.id) === id);
  if (subRow !== -1) {
    if (newRows[row - 1].subRows?.length === 1) {
      newRows.splice(row - 1, 1);
      return;
    }
    newRows[row - 1].subRows?.splice(subRow, 1);
  }
};

export default {
  setTemplates,
  setActiveOTemplateId,
  setActiveOTemplate,
  setActiveDocTypeId,
  setDocTypes,
  setMapperFields,
  setMapperEditRowId,
  setMapperSelectedRowId,
  setMapperRows,
  setMapperAreas,
  setTemplateNewName,
  setNewOtemplate,
  removeOtemplate,
  setCurrentPdfPage,
  deleteRowOrSingleSubRow,
};
